import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { FilePdf, FileWord, FileExcel, FilePicture, FileZip, FileText, FileText2, User, Folder } from '@styled-icons/icomoon';
import { FileCopy, AccountBalanceOutlined, FolderOpenOutlined } from '@material-ui/icons';
import { TreeView, TreeItem } from '@material-ui/lab';
import { Toolbar, Typography, TextField, Tooltip, IconButton } from '@material-ui/core';

import dateHelper from './dateHelper';
import SortChildren from './SortAlgo';

function MountSensor(props) {
    const {
        onMount,
    } = props;

    useEffect(() => {
        onMount(true);

        return () => onMount(false)
    }, []);

    return null;
}

function TypeToIcon(props) {
    var { type } = props;
    type = (type || '').toLowerCase();

    if (type === 'client') {
        return <AccountBalanceOutlined/> // <User size='20' />
    } else if (type === 'folder') {
        return <FolderOpenOutlined/> // <Folder size='20' />
    } else if (type === 'pdf') {
        return <FilePdf size='20' />
    } else if (type === 'docx' || type === 'doc') {
        return <FileWord size='20' />
    } else if (type === 'zip' || type === 'doc') {
        return <FileZip size='20' />
    } else if (type === 'xlst' || type === 'xls') {
        return <FileExcel size='20' />
    } else if (type === 'png' || type === 'jpeg' || type === 'bmp') {
        return <FilePicture size='20' />
    } else if (type === 'txt') {
        return <FileText size='20' />
    } else {
        return <FileText2 size='20'/>
    }
}

export class NodeView extends React.Component {
    constructor(props) {
        super(props);

        this.state = { children: []};

        this.loadChildren = this.loadChildren.bind(this);
    }

    loadChildren() {

        const { node, orderCriteria } = this.props;

        if (!node.hasChildren) {
            return;
        }

        axios.get('/api/docx/children?parentId=' + node.id)
            .then(response => {
                var children = response.data;
                this.setState({ children: children });
            })
            .catch(error => alert(error.message));
    }

    node() {
        return this.props.node;
    }

    render() {
        const { node, dic, onContextMenu, orderCriteria } = this.props;
        var { children } = this.state;
        children = SortChildren(orderCriteria, children);
        const isFolder = node.hasChildren;
        return (
            <TreeItem
                //onLabelClick={event => event.preventDefault()}
                //onIconClick={event => event.preventDefault()}
                onContextMenu={event => onContextMenu(event, node.id)}
                key={node.id} nodeId={node.id} label={<div style={{ display: 'flex', margin: '5px' }}>
                    <TypeToIcon type={node.type} />
                    <div>
                    <Typography style={{ marginLeft: '5px' }} variant='body2' >{node.name}</Typography>
                    {
                        !isFolder ?
                            <Typography style={{
                                marginLeft: '10px'
                            }} color='primary' variant='caption' >
                                ({dateHelper.toShortDate(node.createdOn)} BY {node.author})
                            </Typography>
                            :''
                        }
                        </div>
                </div>}>

                {
                    node.hasChildren ?
                        <>
                            <MountSensor onMount={isMount => {
                                if (isMount) {
                                    this.loadChildren();
                                }
                            }} />
                            {
                                (children || []).map(child => {
                                    return (
                                        <NodeView node={child} dic={dic} parent={dic[node.id]}
                                            onContextMenu={onContextMenu}
                                            orderCriteria={orderCriteria}
                                            ref={ref => dic[child.id] = ref} />
                                    );
                                })
                            }
                        </>
                        :
                        ''
                }
                
            </TreeItem>
        )
    }
}